/* eslint-disable import/no-extraneous-dependencies */
import React, {  useContext, useEffect } from "react";
import { posthog } from "posthog-js";
import { FocalLength } from "@swan-admin/swan-web-component";
import {  SESSION_STORAGE_KEY } from "../../vars";
import { UserDetailsContext } from "../../context/userDetails";
import { getSessionStorage, setSessionStorage } from "../../utils/util";


function DeviceDetails({ onNext }) {
	const { userInfo, setUserInfo, shopDomain, email } = useContext(UserDetailsContext);
	const handlePostEvent = (deviceDetails) => {
		setSessionStorage(SESSION_STORAGE_KEY.FOCAL_LENGTH, deviceDetails.focalLength);
		setSessionStorage(SESSION_STORAGE_KEY.MODEL_NAME, deviceDetails.modelName);
		const payload = {  type: "manual", data: JSON.stringify({ ...deviceDetails }) };
		if (email) {
			payload.email = email;
		}
		posthog.capture(`${shopDomain}/phone_detection`, payload);
	};
	useEffect(() => {
		if (userInfo?.device.focalLength || getSessionStorage(SESSION_STORAGE_KEY.FOCAL_LENGTH)) {
			onNext();
		}
	}, []);

	return (
		<div className="h-full flex-col max-w-md mx-auto  relative  w-full flex justify-start items-start text-center bg-primary rounded-t-[20px]">
			<FocalLength onComplete={(value)=> {
				handlePostEvent(value);
				setUserInfo((prev)=>({...prev, device:value}));
				onNext?.();
			}}/>
		</div>
	);
}

export default DeviceDetails;
